module.exports = __webpack_public_path__ + "img/banner8.3d33fd97.png";